/**
 * Bootstrap Colors mapped to JS arrays.
 * `export const red[100` maps to `red[0]` and `export const red[900` maps to `red[9]`
 * or generally `(### / 100) - 1`.
 */
export const red = [
	'#f8d7da', '#f1aeb5', '#ea868f', '#e35d6a',
	'#dc3545', '#b02a37', '#842029', '#58151c', '#2c0b0e',
];

export const blue = [
	'#cfe2ff', '#9ec5fe', '#6ea8fe', '#3d8bfd',
	'#0d6efd', '#0a58ca', '#084298', '#052c65', '#031633',
];

export const indigo = [
	'#e0cffc', '#c29ffa', '#a370f7', '#8540f5',
	'#6610f2', '#520dc2', '#3d0a91', '#290661', '#140330',
];

export const purple = [
	'#e2d9f3', '#c5b3e6', '#a98eda', '#8c68cd',
	'#6f42c1', '#59359a', '#432874', '#2c1a4d', '#160d27',
];

export const pink = [
	'#f7d6e6', '#efadce', '#e685b5', '#de5c9d',
	'#d63384', '#ab296a', '#801f4f', '#561435', '#2b0a1a',
];

export const orange = [
	'#ffe5d0', '#fecba1', '#feb272', '#fd9843',
	'#fd7e14', '#ca6510', '#984c0c', '#653208', '#331904'
];

export const yellow = [
	'#fff3cd', '#ffe69c', '#ffda6a', '#ffcd39',
	'#ffc107', '#cc9a06', '#997404', '#664d03', '#332701',
];

export const green = [
	'#d1e7dd', '#a3cfbb', '#75b798', '#479f76',
	'#198754', '#146c43', '#0f5132', '#0a3622', '#051b11',
];

export const teal = [
	'#d2f4ea', '#a6e9d5', '#79dfc1', '#4dd4ac',
	'#20c997', '#1aa179', '#13795b', '#0d503c', '#06281e',
];

export const cyan = [
	'#cff4fc', '#9eeaf9', '#6edff6', '#3dd5f3',
	'#0dcaf0', '#0aa2c0', '#087990', '#055160', '#032830',
];

export const gray = [
	'#f8f9fa', '#e9ecef', '#dee2e6', '#ced4da',
	'#adb5bd', '#6c757d', '#495057', '#343a40', '#212529',
];

export const light = gray[0];
export const grayDark = gray[7];
export const dark = gray[8];

export const primary = blue[4];
export const secondary = gray[5];
export const success = green[4];
export const info = cyan[4];
export const warning = yellow[4];
export const danger = red[4];
